// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.message-container .foundaton-account-number {
  font-size: 16px;
}
.message-container .btn-link {
  padding-top: 10px;
}
.message-container form .form-group {
  margin: 0 0 30px;
}
.message-container form .form-group h2 {
  margin-bottom: 20px;
}
.message-container form .form-group textarea {
  width: 100%;
  height: 140px;
  margin: 3px 0;
  border-color: #cccccc;
  color: #191919 !important;
  font-family: "Omnes-ATT-W02" !important;
  font-size: 16px !important;
  box-shadow: inset 0px 2px 0px 0px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
}
.message-container form .form-group textarea:focus {
  outline: none !important;
  border: 1px solid #0568ae;
}
.message-container form .form-group .radio {
  margin-bottom: 20px;
  width: 80%;
}
.message-container form .form-group .radio:last-child {
  margin-bottom: 0;
}
.message-container form .form-group .radio .fan-dropdown {
  margin: 20px 33px 0;
  width: 60%;
  font-size: 16px;
}
.message-container form .form-group .radio .fan-dropdown .selectWrap {
  margin-left: 0;
  top: 0;
}
.message-container form .form-group .radio .search-fan {
  position: relative;
}
.message-container form .form-group .radio .search-fan input {
  height: 36px !important;
  margin: 6px 0 0;
  opacity: 1;
  padding-right: 30px;
  position: static;
  width: 100%;
}
.message-container form .form-group .radio .search-fan .search-icon {
  position: absolute;
  right: 0;
  top: 15px;
}
.message-container form .form-group .radio .search-fan span {
  font-family: Omnes-ATT-W02;
  font-size: 16px;
}
.message-container form .form-group .radio .divider {
  margin: 0;
  padding: 5px;
  position: static;
}
.message-container form .form-group .radio a {
  padding-left: 0;
}
.message-container form .form-group .error-text {
  color: hsl(0, 66%, 49%);
  margin: 5px 0;
}
.message-container form .form-group .error-text i {
  color: hsl(0, 66%, 49%);
}
.message-container form .form-group .error {
  color: hsl(0, 66%, 49%);
}
.message-container form .form-group .error input {
  border-color: hsl(0, 66%, 49%);
  color: hsl(0, 66%, 49%);
}
.message-container form .form-group .fan-search-bar {
  margin: 20px 0 0 33px;
  width: 65%;
}
.message-container .cta {
  border-top: 1px solid #d2d2d2;
  padding: 30px 0 60px;
}

@media (max-width: 1024px) {
  .message-container form div:nth-last-of-type(2) {
    margin-bottom: 20px;
  }
  .message-container form .cta {
    padding: 20px 0 30px;
    margin: 0 1px;
  }
  .message-container form .cta a {
    text-align: center;
  }
  .message-container form .cta button {
    margin: 0 0 0 20px;
    text-align: center;
  }
  .message-container form .cta .btn {
    padding: 0;
  }
  .message-container form .cta .btn-link {
    padding-top: 20px;
  }
  .message-container form .form-group .fan-search-bar {
    width: 90%;
  }
  .message-container form .search-fan input {
    width: 140%;
  }
  .message-container .btn-sms-message {
    padding: 10px 19px 0 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/sendSMS/message/message.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAhJE;EACE,eAAA;AAkJJ;AA/IE;EACE,iBAAA;AAiJJ;AA9II;EACE,gBAAA;AAgJN;AA9IM;EACE,mBAAA;AAgJR;AA7IM;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,qDAAA;EACA,kBAAA;AA+IR;AA7IQ;EACE,wBAAA;EACA,yBAAA;AA+IV;AA1IM;EACE,mBAAA;EACA,UAAA;AA4IR;AA1IQ;EACE,gBAAA;AA4IV;AAzIQ;EACE,mBAAA;EACA,UAAA;EACA,eAAA;AA2IV;AAzIU;EACE,cAAA;EACA,MAAA;AA2IZ;AAvIQ;EACE,kBAAA;AAyIV;AAvIU;EACE,uBAAA;EACA,eAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AAyIZ;AAtIU;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AAwIZ;AArIU;EACE,0BAAA;EACA,eAAA;AAuIZ;AAlIQ;EACE,SAAA;EACA,YAAA;EACA,gBAAA;AAoIV;AAjIQ;EACE,eAAA;AAmIV;AA/HM;EACE,uBAAA;EACA,aAAA;AAiIR;AA/HQ;EACE,uBAAA;AAiIV;AA7HM;EACE,uBAAA;AA+HR;AA7HQ;EACE,8BAAA;EACA,uBAAA;AA+HV;AA3HM;EACE,qBAAA;EACA,UAAA;AA6HR;AAvHE;EACE,6BAAA;EACA,oBAAA;AAyHJ;;AFxNI;EEsGE;IACE,mBAAA;EAsHN;EApHI;IACE,oBAAA;IACA,aAAA;EAsHN;EApHM;IACI,kBAAA;EAsHV;EAnHM;IACE,kBAAA;IACA,kBAAA;EAqHR;EAlHM;IACE,UAAA;EAoHR;EAjHM;IACE,iBAAA;EAmHR;EA9GM;IACE,UAAA;EAgHR;EA3GM;IACE,WAAA;EA6GR;EAzGE;IACE,yBAAA;EA2GJ;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.message-container {\n  .foundaton-account-number {\n    font-size: 16px;\n  }\n  \n  .btn-link {\n    padding-top: 10px;\n  }\n  form {\n    .form-group {\n      margin: 0 0 30px;\n\n      h2 {\n        margin-bottom: 20px;\n      }\n   \n      textarea {\n        width: 100%;\n        height: 140px;\n        margin: 3px 0;\n        border-color: color(outOfCompliance);\n        color: color(inverse,darker) !important;\n        font-family: 'Omnes-ATT-W02' !important;\n        font-size:16px !important;\n        box-shadow: inset 0px 2px 0px 0px rgba(0, 0, 0, 0.08);\n        border-radius : 6px;\n\n        &:focus { \n          outline: none !important;\n          border:1px solid #0568ae;\n        }\n       \n      }\n\n      .radio {\n        margin-bottom: 20px;\n        width: 80%;\n        \n        &:last-child {\n          margin-bottom: 0;\n        }\n\n        .fan-dropdown {\n          margin: 20px 33px 0;\n          width: 60%;\n          font-size: 16px;\n\n          .selectWrap {\n            margin-left: 0;\n            top: 0;\n          }\n        }\n\n        .search-fan {\n          position: relative;\n\n          input {\n            height: 36px !important;\n            margin: 6px 0 0;\n            opacity: 1;\n            padding-right: 30px;\n            position: static;\n            width: 100%;\n          }\n\n          .search-icon {\n            position: absolute;\n            right: 0;\n            top: 15px;\n          }\n\n          span{\n            font-family: Omnes-ATT-W02;\n            font-size: 16px;\n          }\n\n        }\n\n        .divider {\n          margin: 0;\n          padding: 5px;\n          position: static;\n        }\n\n        a {\n          padding-left: 0;\n        }\n      }\n\n      .error-text {\n        color: color(danger, base);\n        margin: 5px 0;\n\n        i {\n          color: color(danger, base);\n        }\n      }\n\n      .error {\n        color: color(danger, base);\n\n        input {\n          border-color: color(danger, base);;\n          color: color(danger, base);\n        }\n      }\n\n      .fan-search-bar {\n        margin: 20px 0 0 33px;\n        width: 65%;\n      }\n\n    }\n  }\n\n  .cta {\n    border-top:  1px solid color(default, dark);\n    padding: 30px 0 60px;\n  }\n}\n\n@include respond-to(small) {\n  .message-container {\n    form {\n      div:nth-last-of-type(2) {\n        margin-bottom: 20px;\n      }\n      .cta {\n        padding: 20px 0 30px;\n        margin: 0 1px;\n\n        a {\n            text-align: center;\n        }\n\n        button {\n          margin: 0 0 0 20px;\n          text-align: center;\n        }\n\n        .btn {\n          padding: 0;\n        }\n        \n        .btn-link {\n          padding-top: 20px;\n        }\n      }\n\n      .form-group {\n        .fan-search-bar {\n          width: 90%;\n        }\n      }\n\n      .search-fan {\n        input {\n          width: 140%;\n        }\n      }\n    }\n    .btn-sms-message {\n      padding: 10px 19px 0 18px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
